import {getField} from 'vuex-map-fields';
import api from "./../../../util/api";
import {apiAction, commonMutations, commonState, getCrudMutations} from "../../common";
import DataWrapper from "../../../util/DataWrapper";
import {WrapperFactory} from "../../../util/WrapperFactory";
import {Formula} from "../../../models/Formula";
import form from './modules/formula-form';

const state = () => ({
    ...commonState(),
    formulas:new DataWrapper()
});


// getters
const getters = {
    getField,
};

// actions
const actions = {
    getFormulas:apiAction(async ({ commit, rootGetters }, filters, page=1)=>{
        let result = await api.formulas.get(rootGetters['account/token'], rootGetters['account/companyId'], {
            page:page,
            ...filters
        });

        commit('update', result);
    })
};

// mutations
const mutations = {
    ...commonMutations,
    push:(state, formula)=>{
        state.formulas.data.push(formula);
    },
    replace:(state, formula)=>{
        let index = state.formulas.data.findIndex(t=>t.id===formula.id);
        state.formulas.data.splice(index, 1, formula);
    },
    delete:(state, formula)=>{
        let index = state.formulas.data.findIndex(t=>t.id===formula.id);
        state.formulas.data.splice(index, 1);
    },
    update:(state, formulas)=>{
        state.formulas = state.formulas.updateData(formulas);
    },
};


export default {
    namespaced: true,
    modules:{
        form
    },
    state,
    getters,
    actions,
    mutations
};